import Model from './model.js';

export default class BankAccount extends Model {
    urlRoot() { return '/BankAccounts'; }

    defaults() {
        return {
            isPayer: false,
            isPayee: true,
            companyId: null, // TODO do we need this field?
            employeeId: null // TODO do we need this field?
        };
    }

    constraints() {
        return {
            bankName: {presence: {message: '^Bank Name is required'}},
            bankBnmCode: {presence: {message: '^BNM code is required'}},
            bankSwiftCode: {presence: {message: '^SWIFT code is required'}},

            holderName: function(value, attrs) {
                let constraints = {
                    presence: {message: '^Account\'s holder Name is required'}
                };

                if ((attrs.bankBnmCode || null) === '18') {
                    constraints.length = {
                        maximum: 40,
                        message: '^Account Holder\'s Name ' +
                        'should not more than 40 Char'
                    };
                }

                return constraints;
            },
            number: function(value, attrs) {
                let constraints = {
                    presence: {message: '^Account number is required'}
                };

                if ((attrs.bankBnmCode || null) === '33') {
                    constraints.numericality = {
                        onlyInteger: {message: '^Only numbers are allowed'}
                    };
                    constraints.length = {
                        is: 10,
                        message: '^Account number must be 10 digits long'
                    };
                } else if ((attrs.bankBnmCode || null) === '27') {
                    constraints.numericality = {
                        onlyInteger: {message: '^Only numbers are allowed'}
                    };
                    constraints.length = {
                        is: 12,
                        message: '^Account number must be 12 digits long'
                    };
                } else if ((attrs.bankBnmCode || null) === '24') {
                    // HLB
                    constraints.numericality = {
                        onlyInteger: {message: '^Only numbers are allowed'}
                    };
                    constraints.length = {
                        is: 11,
                        message: '^Account number must be 11-digit long'
                    };
                } else if ((attrs.bankBnmCode || null) === '18') {
                    // RHB
                    constraints.numericality = {
                        onlyInteger: {message: '^Only numbers are allowed'}
                    };
                    constraints.length = {
                        is: 14,
                        message: '^Account number must be ' +
                            '14 digit long'
                    };
                } else if ((attrs.bankBnmCode || null) === '29') {
                    // OCBC
                    constraints.numericality = {
                        onlyInteger: {message: '^Only numbers are allowed'}
                    };
                    if (attrs.isPayer) {
                        constraints.length = {
                            is: 10,
                            message: '^Account number must be ' +
                                '10 digit long'
                        };
                    }
                } else if ((attrs.bankBnmCode || null) === '22') {
                    // HSBC
                    constraints.numericality = {
                        onlyInteger: {message: '^Only numbers are allowed'}
                    };
                    if (attrs.isPayer) {
                        constraints.length = {
                            is: 12,
                            message: '^Account number must be 12 digit long'
                        };
                    }
                } else if ((attrs.bankBnmCode || null) === '26') {
                    // UOB
                    constraints.numericality = {
                        onlyInteger: {message: '^Only numbers are allowed'}
                    };
                }

                return constraints;
            },

            organizationCode: function(value, attrs) {
                if (
                    ['27', '33', '35', '18'].indexOf(attrs.bankBnmCode) >= 0 &&
                    attrs.isPayer
                ) {
                    if (
                        attrs.accountType === 'enterprise' ||
                        attrs.accountType === 'maybank2u'
                    ) {
                        return false;
                    }
                    const constraints = {
                        presence: {message: '^Organization code is required'}
                    };

                    if (attrs.bankBnmCode === '35') {
                        constraints.length = {
                            is: 5,
                            message: '^The organization code must be 5 ' +
                                'digits long'
                        };
                    } else if (attrs.bankBnmCode === '33') {
                        constraints.length = {
                            is: 3,
                            message: '^The organization code must be 3 ' +
                                'digits long'
                        };
                    } else if (attrs.bankBnmCode === '18') {
                        //RHB
                        constraints.length = {
                            is: 6,
                            message: '^The Corporate ID must be 6 digits long'
                        };
                    } else if (attrs.bankBnmCode === '27' && attrs.accountType === 'maybank2e') {
                        constraints.length = {
                            maximum: 30,
                            message: '^The Corporate ID must be at most 30 digits long'
                        };
                    }

                    return constraints;
                }

                return false;
            },

            originatorId: function(value, attrs) {
                if (attrs.bankBnmCode === '27' && attrs.isPayer) {
                    if (attrs.accountType === 'maybank2e') {
                        return false;
                    }
                    return {
                        presence: {message: '^Originator ID is required'},
                        length: {
                            is: 5,
                            message: '^The originator ID  must be 5 digits long'
                        },
                        numericality: {
                            onlyInteger: {message: '^Only numbers are allowed'}
                        }
                    };
                }

                return false;
            },

            transactionType: function(value, attrs) {
                if (
                    ['18', '24', '26', '33'].indexOf(attrs.bankBnmCode) >= 0 &&
                        attrs.isPayer
                ) {
                    const constraints = {
                        presence: {
                            message: '^Payment mode/transaction type is required'
                        }
                    };

                    return constraints;
                }

                return false;
            },

            accountType: function(value, attrs) {
                if (attrs.bankBnmCode !== '27' || !attrs.isPayer) {
                    return false;
                }

                return {
                    presence: {
                        message: '^Account type is required'
                    }
                };
            },

            hsbcNetPaymentSetNo: function(value, attrs) {
                if (attrs.bankBnmCode !== '22' || !attrs.isPayer) {
                    return false;
                }

                return {
                    length: {
                        is: 3,
                        message: '^Must be 3 characters long'
                    }
                };
            },

            hsbcNetId: function(value, attrs) {
                if (attrs.bankBnmCode !== '22' || !attrs.isPayer) {
                    return false;
                }

                return {
                    length: {
                        minimum: 17,
                        maximum: 18,
                        message: '^Length must be 17-18 characters'
                    }
                };
            },

            hsbcConnectId: function(value, attrs) {
                if (attrs.bankBnmCode !== '22' || !attrs.isPayer) {
                    return false;
                }

                return {
                    length: {
                        is: 11,
                        message: '^Must be 11 characters long'
                    }
                };
            },

            // UOB Company ID
            companyCode: function(value, attrs) {
                if (attrs.bankBnmCode !== '26' || !attrs.isPayer) {
                    return false;
                }

                return {
                    presence: {
                        message: '^Company ID is required'
                    }
                }
            }
        };
    } // end of constraints

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    initialize() {
        this.idAttribute = 'objectId';
        return super.initialize(...arguments);
    }

    getSupportedTransactionTypes() {
        if (this.get('bankBnmCode') === '18') {
            /* RHB transaction types */
            return {
                '20': 'Rentas',
                '30': 'IBG'
            };
        }

        if (this.get('bankBnmCode') === '33') {
            // Public Bank
            const types = {
                'service': {
                    'LGP': 'IBG',
                    'LSP': 'Rentas',
                    'LBC': 'BC/DD'
                },
                'enterprise': {
                    'LGP': 'PBB',
                    'LSP': 'IBG',
                    'LBC': 'REN'
                }
            };
            const type = this.get('accountType');
            return types[type];
        }

        if (this.get('bankBnmCode') === '24') {
            // HLB
            return {
                'RTS': 'Rentas',
                'IBG': 'IBG'
            };
        }

        if (this.get('bankBnmCode') === '26') {
            // UOB
            return {
                'IBG': 'IBG',
                'IFT': 'IFT'
            };
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./app/new-models/bank-account.js